<template>
  <div>
    <navigation/>
    <div class="pale-bgcolor">
      <div class="ay_contain" style="margin-top: -20px">
        <div class="ay_title">
          亮照异议
        </div>
        <form id="complain_form">
          <div class="ay_userinfo">
            <div class="ayui_title">
              <span class="ayui_title_span"></span>是否为该企业员工 ：
              <el-checkbox v-model="siteComplain.isCompanyMan" value="1">是
              </el-checkbox>
            </div>
          </div>
          <div class="ay_userinfo">
            <div class="ayui_title">
              <span></span>联系方式：
            </div>
            <div class="ayui_list">
              <div class="ayui_item" style="width: 100%;">
                <label><i class="i-sign">∗</i> 联系人：</label>
                <input type="text" maxlength="50" name="name" id="name" v-model="siteComplain.complainPersonName">
                <el-tag type="danger" v-if="complainPersonNameMsg != null">{{ complainPersonNameMsg }}</el-tag>
              </div>
              <div class="ayui_item" style="width: 100%;">
                <label><i class="i-sign">∗</i> 联系电话：</label>
                <input type="text" maxlength="50" name="phone" id="phone" v-model="siteComplain.complainPersonPhone">
                <el-tag type="danger" v-if="complainPersonPhoneMsg != null">{{ complainPersonPhoneMsg }}</el-tag>
              </div>

              <div style="clear: both;"></div>
            </div>

          </div>
          <div class="ay_userinfo ay_user">
            <div class="ayui_title">
              <span></span>问题描述：
            </div>
            <div class="ayui_list">
              <div class="ayui_item">
                <label>问题类型：</label>
                <el-select style="margin-left: 6px" name="complainType" id="complainType" v-model="siteComplain.complainType">
                  <el-option value="1" label="企业基本信息">企业基本信息</el-option>
                  <el-option value="2" label="备案信息">备案信息</el-option>
                </el-select>
                <el-tag type="danger" v-if="complainTypeMsg != null">{{ complainTypeMsg }}</el-tag>
              </div>
              <div class="ayui_item ayui_textarea">
                <label><i class="i-sign">∗</i> 纠错内容：</label>
                <textarea name="description" style="width: 500px" maxlength="500" id="description"
                          v-model="siteComplain.complainDescription"></textarea>
                <el-tag type="danger" style="position: absolute;top: 20px;left: 648px"
                        v-if="complainDescriptionMsg != null">{{ complainDescriptionMsg }}
                </el-tag>
              </div>
              <div class="ayui_item ayui_vail">
                <label><i class="i-sign">∗</i> 验证码：</label>
                <input type="text" placeholder="请输入验证码" id="KaptchaCode" name="kaptcha" v-model="siteComplain.verCode">
                <div class="lg_validation">
                  <img id="kaptcha" @click="kaptchaClick" :src="kaptchaUrl"
                       style="width:100px; height:36px; position: absolute; left:300px; top:0px; border:1px solid #d2d6de;cursor:pointer;"
                       alt="验证码"/>
                </div>
                <el-tag type="danger" v-if="verCodeMsg != null" style="margin-left: 102px">{{ verCodeMsg }}</el-tag>
              </div>
              <div style="clear: both;"></div>
            </div>

          </div>
          <div class="ar-btn" id="submitForm" @click="submit">确定</div>
          <div class="ay_botton ay_btn_1" style="text-align: center;display:none">申请</div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import utilAPi from '../assets/js/utils'
import navigation from './navigation'

export default {
  name: 'addSiteComplain',
  components: {
    'navigation': navigation
  },
  data: function () {
    return {
      verCodeMsg: null,
      complainDescriptionMsg: null,
      complainTypeMsg: null,
      complainPersonPhoneMsg: null,
      complainPersonNameMsg: null,
      kaptchaUrl: this.config.kaptchaUrl,
      downCount: 60,
      siteComplain: {
        verCode: null,
        complainId: null,
        isCompanyMan: null,
        siteBaseId: this.$route.params.siteBaseId,
        complainPersonPhone: null,
        complainPersonName: null,
        complainType: null,
        complainDescription: null,
        complainStatus: null
      },
      stepNum: 1
    }
  },
  created() {
    this.$nextTick(() => {
      this.kaptchaClick()
    });
    this.getUserInfo()
  }, methods: {
    getUserInfo() {
      let _self = this
      _self.axios.get(
        _self.api.getUserInfo
      ).then(res => {
        if (res.data.code === 10000) {
          this.isLogin = true
          this.userInfo = res.data.obj
        } else {
          this.isLogin = false
        }
      }).catch(err => {
        this.$message.error('网络请求异常!')
      })
    },
    /**
     * 更新验证码
     */
    kaptchaClick() {
      var img = document.getElementById("kaptcha");
      img.setAttribute("src", this.kaptchaUrl);
    },
    /**
     * 提交申请接口
     */
    submit() {
      if (!this.checkInput()) {
        return
      }
      let _self = this
      this.siteComplain.isCompanyMan = this.siteComplain.isCompanyMan === true ? 1: 0
      _self.axios.post(_self.api.addSiteComplain, this.siteComplain).then(res => {
        this.siteComplain.isCompanyMan = this.siteComplain.isCompanyMan === 1 ? true : false
        if (res.data.code === 10000) {
          this.$confirm('投诉成功.工作人员核实之后进行处理', '温馨提示', {
            type: 'success',
            center: true,
            customClass:'warn-dialog'
          }).then(() => {
            this.$router.push({
              path: '/index'
            })
          }).catch(() => { });
        } else {
          this.$message.error(res.data.message)
          this.kaptchaClick()
        }
      }).catch(err => {
        this.$message.error('网络请求异常!')
        this.kaptchaClick()
      })
    },
    /**
     * 检查表单
     */
    checkInput() {
      let flag = true
      if (this.siteComplain.complainDescription == null || this.siteComplain.complainDescription === '') {
        this.complainDescriptionMsg = '请填写纠错内容!'
        flag = false
      } else {
        this.complainDescriptionMsg = null
      }
      if (this.siteComplain.complainPersonName == null || this.siteComplain.complainPersonName === '') {
        this.complainPersonNameMsg = '请填写联系人!'
        flag = false
      } else {
        this.complainPersonNameMsg = null
      }
      if (this.siteComplain.complainPersonPhone == null || this.siteComplain.complainPersonPhone === '') {
        this.complainPersonPhoneMsg = '请填写联系电话!'
        flag = false
      } else {
        this.complainPersonPhoneMsg = null
      }
      if (this.siteComplain.complainType == null || this.siteComplain.complainType === '') {
        this.complainTypeMsg = '请选择问题类型!'
        flag = false
      } else {
        this.complainTypeMsg = null
      }
      if (this.siteComplain.verCode == null || this.siteComplain.verCode === '') {
        this.verCodeMsg = '请输入验证码!'
        flag = false
      } else {
        this.verCodeMsg = null
      }
      return flag
    }
  }
}
</script>

<style>
@import '../assets/css/aicUser.css';

.ar-btn {
  width: 130px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-radius: 2px;
  font-size: 16px;
  color: #fefefe;
  border-color: #088ef0;
  margin-top: 50px;
  margin-left: 220px;
  margin-bottom: 16px;
  cursor: pointer;
  background: -webkit-gradient(linear, left top, left bottom, from(#64a8ff), to(#337adb));
  background: linear-gradient(#64a8ff, #337adb);
}
</style>



// WEBPACK FOOTER //
// src/components/addSiteComplain.vue